export default {
  H1: 'heading_1_color',
  H2: 'heading_2_color',
  H3: 'heading_3_color',
  H4: 'heading_4_color',
  H5: 'heading_5_color',
  H6: 'heading_6_color',
  P: 'paragraph_color',
  BLOCKQUOTE: 'blockquote_color',
};
